import { render } from "./detail.vue?vue&type=template&id=7b1eda53&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=7b1eda53&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7b1eda53"

export default script